import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { environment } from '@env/environment';
import { WA_WINDOW } from '@ng-web-apis/common';
import { TUI_IS_MOBILE } from '@taiga-ui/cdk';
import { TuiButton } from '@taiga-ui/core';

@Component({
  selector: 'app-ios-udid-finder-hero-section',
  imports: [TuiButton],
  templateUrl: './ios-udid-finder-hero-section.component.html',
  styleUrl: './ios-udid-finder-hero-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IosUdidFinderHeroSectionComponent {
  private readonly window = inject(WA_WINDOW);
  protected readonly isMobile = inject(TUI_IS_MOBILE);
  protected readonly profileUrl = `${environment.apiBaseUrl}/v1/ios-udid-profile?callbackUrl=${encodeURIComponent(`${this.window.location.origin}/tools/ios-udid-finder/`)}`;
  protected readonly qrCodeUrl = `${environment.apiBaseUrl}/v1/qrcodes?content=${encodeURIComponent(this.profileUrl)}`;
}
